import { RemoteUnlinkProfessional } from 'data/usecases';
import { UnlinkProfessionalUseCaseInterface } from 'domain/usecases';
import { makeApiUrlUnlinkProfessional } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUnlinkProfessional =
  (): UnlinkProfessionalUseCaseInterface =>
    new RemoteUnlinkProfessional(
      makeApiUrlUnlinkProfessional(),
      makeAxiosHttpClient(),
    );
